import script from "./PatientTodos.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientTodos.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__